export const FETCH_LIST_PATIENTS_REQUEST= "FETCH_LIST_PATIENTS_REQUEST";
export const FETCH_LIST_PATIENTS_SUCCESS= "FETCH_LIST_PATIENTS_SUCCESS";
export const FETCH_LIST_PATIENTS_FAILURE= "FETCH_LIST_PATIENTS_FAILURE";


export const FETCH_ALL_LIST_PATIENTS_REQUEST= "FETCH_ALL_LIST_PATIENTS_REQUEST";
export const FETCH_ALL_LIST_PATIENTS_SUCCESS= "FETCH_ALL_LIST_PATIENTS_SUCCESS";
export const FETCH_ALL_LIST_PATIENTS_FAILURE= "FETCH_ALL_LIST_PATIENTS_FAILURE";

// View single patient
export const FETCH_PATIENT_REQUEST= "FETCH_PATIENT_REQUEST";
export const FETCH_PATIENT_SUCCESS= "FETCH_PATIENT_SUCCESS";
export const FETCH_PATIENT_FAILURE= "FETCH_PATIENT_FAILURE";

// Add patient
export const ADD_PATIENT_REQUEST= "ADD_PATIENT_REQUEST";
export const ADD_PATIENT_SUCCESS= "ADD_PATIENT_SUCCESS";
export const ADD_PATIENT_FAILURE= "ADD_PATIENT_FAILURE";

// Edit patient
export const UPDATE_PATIENT_REQUEST= "UPDATE_PATIENT_REQUEST";
export const UPDATE_PATIENT_SUCCESS= "UPDATE_PATIENT_SUCCESS";
export const UPDATE_PATIENT_FAILURE= "UPDATE_PATIENT_FAILURE";

// Delete patient
export const DELETE_PATIENT_REQUEST= "DELETE_PATIENT_REQUEST";
export const DELETE_PATIENT_SUCCESS= "DELETE_PATIENT_SUCCESS";
export const DELETE_PATIENT_FAILURE= "DELETE_PATIENT_FAILURE";

// Reset current patient
export const RESET_CURRENT_PATIENT= "RESET_CURRENT_PATIENT";

export const HISTORY_PATIENTS_REQUEST="HISTORY_PATIENTS_REQUEST";
export const HISTORY_PATIENTS_SUCCESS="HISTORY_PATIENTS_SUCCESS";
export const HISTORY_PATIENTS_FAILURE="HISTORY_PATIENTS_FAILURE";
